import React, { useState, useEffect } from 'react';
import { ShoppingCart, ChevronDown, Menu, X } from 'lucide-react';
import Hero from '../../components/Hero';
import Official from '../../components/Official';
import Included from '../../components/Included';
import Features from '../../components/Features';
import Trust from '../../components/Trust';
import Offer from '../../components/Offer';
import Footer from '../../components/Footer';

const CAMPAIGN_SOURCE = 'papa-futbolero';

export const PapaFutbolero = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  // Store campaign source in sessionStorage so the order service can include it
  useEffect(() => {
    sessionStorage.setItem('campaign_source', CAMPAIGN_SOURCE);
  }, []);

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setMobileMenuOpen(false);
    }
  };

  return (
    <div className="min-h-screen bg-white">
      {/* Header */}
      <header className="fixed top-0 left-0 right-0 z-50 bg-white/95 backdrop-blur-md border-b border-gray-200">
        <div className="container mx-auto px-4 lg:px-8">
          <div className="flex items-center justify-between h-20">
            {/* Logo */}
            <div className="flex-shrink-0">
              <img 
                src="https://customer-assets.emergentagent.com/job_13e5738d-7aa3-4072-b101-9672dafbd61a/artifacts/j65cu3zm_logo.jpg" 
                alt="Gafas La Tri - Logo Oficial" 
                className="h-14 w-auto object-contain"
                loading="eager"
                fetchpriority="high"
                width="120"
                height="56"
              />
            </div>

            {/* Desktop Navigation */}
            <nav className="hidden md:flex items-center space-x-8">
              <button 
                onClick={() => scrollToSection('beneficios')} 
                className="text-gray-700 hover:text-blue-900 font-medium transition-colors"
              >
                Beneficios
              </button>
              <button 
                onClick={() => scrollToSection('modelos')} 
                className="text-gray-700 hover:text-blue-900 font-medium transition-colors"
              >
                Modelos
              </button>
              <button 
                onClick={() => scrollToSection('incluye')} 
                className="text-gray-700 hover:text-blue-900 font-medium transition-colors"
              >
                Qué incluye
              </button>
              <a
                href="https://www.instagram.com/gafasdelatri"
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-700 hover:text-blue-900 font-medium transition-colors flex items-center gap-2"
              >
                <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/>
                </svg>
                Instagram
              </a>
              <button 
                onClick={() => scrollToSection('comprar')} 
                className="bg-blue-900 text-white px-6 py-2.5 rounded-lg font-semibold hover:bg-blue-800 transition-all hover:scale-105"
              >
                Comprar
              </button>
            </nav>

            {/* Mobile Menu Button */}
            <button
              onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
              className="md:hidden text-gray-700 hover:text-blue-900 transition-colors"
            >
              {mobileMenuOpen ? <X size={28} /> : <Menu size={28} />}
            </button>
          </div>

          {/* Mobile Menu */}
          {mobileMenuOpen && (
            <div className="md:hidden py-4 border-t border-gray-200 bg-white">
              <nav className="flex flex-col space-y-4">
                <button 
                  onClick={() => scrollToSection('beneficios')} 
                  className="text-left text-gray-700 hover:text-blue-900 font-medium transition-colors py-2"
                >
                  Beneficios
                </button>
                <button 
                  onClick={() => scrollToSection('modelos')} 
                  className="text-left text-gray-700 hover:text-blue-900 font-medium transition-colors py-2"
                >
                  Modelos
                </button>
                <button 
                  onClick={() => scrollToSection('incluye')} 
                  className="text-left text-gray-700 hover:text-blue-900 font-medium transition-colors py-2"
                >
                  Qué incluye
                </button>
                <a
                  href="https://www.instagram.com/gafasdelatri"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-left text-gray-700 hover:text-blue-900 font-medium transition-colors py-2 flex items-center gap-2"
                >
                  <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                    <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/>
                  </svg>
                  Instagram
                </a>
                <button 
                  onClick={() => scrollToSection('comprar')} 
                  className="bg-blue-900 text-white px-6 py-3 rounded-lg font-semibold hover:bg-blue-800 transition-colors text-left"
                >
                  Comprar
                </button>
              </nav>
            </div>
          )}
        </div>
      </header>

      {/* Main Content */}
      <main className="pt-20">
        <Hero scrollToSection={scrollToSection} />
        <Official />
        <Offer
          colorHeading="Elige el color que va contigo"
          headingTitle="Una para ti,"
          headingTitleAccent="otra para compartir"
          headingSubtitle="Lleva dos pares con precio especial y comparte la pasión con alguien más de tu familia."
        />
        <Included />
        <Features />
        <Trust />
      </main>

      <Footer />
    </div>
  );
};

export default PapaFutbolero;
